document.addEventListener("DOMContentLoaded", function () {
  // Function to check and update the visibility of complementarydiv
  function checkComplementaryDiv() {
    var cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer && cartDrawer.shadowRoot) {
      var complementaryDiv = cartDrawer.shadowRoot.querySelector(
        'div[part="complementarydiv"]'
      );
      if (complementaryDiv) {
        var slot = complementaryDiv.querySelector('slot[name="complementary"]');
        var slottedContent = slot.assignedNodes({ flatten: true });

        if (
          slottedContent.length === 0 ||
          slottedContent.every((node) => node.textContent.trim() === "")
        ) {
          complementaryDiv.style.display = "none";
          console.log("complementarydiv slot is empty");
          cartDrawer.classList.add("complementary-empty");
        } else {
          complementaryDiv.style.display = ""; // Reset display if not empty
          console.log("complementarydiv slot is NOT empty");
          cartDrawer.classList.remove("complementary-empty");
        }
      }
    }
  }

  // Function to delay and then check visibility
  function delayCheck() {
    setTimeout(checkComplementaryDiv, 500); // Delay the function call by 500 milliseconds
  }

  // Initially check when the page is loaded
  checkComplementaryDiv();

  // Listen for a custom event that is assumed to be dispatched when a product is added to the cart
  document.addEventListener("product:add", function () {
    console.log("product add listener");
    delayCheck(); // Check visibility when a product is added
  });

  // Re-check whenever the cart is changed
  document.addEventListener("cart:change", function (event) {
    console.log("cart change listener");
    // fetchCart = event.detail["cart"]; // Update the cart data
    delayCheck(); // Check the visibility of the complementary div
  });

  document.addEventListener("variant:add", function () {
    console.log("variant add listener");
    delayCheck(); // Check visibility when a variant is added
  });

  // Re-check when the page is revisited (e.g., back button in the browser)
  window.addEventListener("pageshow", function (event) {
    console.log("pageshow listener");
    if (event.persisted) {
      // fetchCart = createCartPromise();
      delayCheck(); // Check after page show
    }
  });

  // Re-check if the cart needs to be refreshed
  document.addEventListener("cart:refresh", function () {
    console.log("cart refresh listener");
    // fetchCart = createCartPromise();
    delayCheck(); // Check on cart refresh
  });
});
